import axios from 'axios';
import { useEffect, useState } from 'react'
import Settings from '../../../../../inc/Settings'; 
import Helper from '../../../../../inc/Helper'; 
import Button from '../../../../../components/inc/Button'; 
import Popup from '../../../../../components/Popup/Popup'; 
import { getPopupMessageBasedOnStatus } from '../../../../../inc/Validation'; 
import ConditionalWorkflowModule from './ConditionalWorkflowModule';
import NewOverlayLoader from '../../../../../components/PurchaseRequisition/common/NewOverlayLoader';
import Input from '../../../../../components/Forms/Input';
import { connect } from 'react-redux';
import Api from '../../../../../inc/Api';

const BasicSettings = (props) => {
  const [nodeLabel, setnodeLabel] = useState('');
  const [fieldDictionaryData, setFieldDictionaryData] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);

  const query = new URLSearchParams(window.location.search);
  const templateId = query.get('id');
  const workflowBodyId = query.get('to_id');

  useEffect(() => {
    if (props.onClickNode) {
      getLabelOfConditions()
    }
    getFieldData() 
  }, []);

  const getLabelOfConditions = () => {
    setApiLoading(true);
    let api = Api;
    api.setUserToken();
    api.axios().get(Settings.baseUrl + `workflow/node/get-label?node_id=${props.onClickNode}`).then((res) => {
      if (res.data.success) {
        setnodeLabel(res?.data?.data?.label); 
        setApiLoading(false);
      }
    }).catch((err) => {
      getPopupMessageBasedOnStatus(err);
      setApiLoading(false);
    })
  };

  const getFieldData = () => {
    const tenantId = props?.user?.tenant_id;
    const url = `template/details?template_id=${templateId}${
      tenantId ? `&tenant_id=${tenantId}` : ''
    }`;

    let api = Api;
    api.setUserToken();
    api.axios().get(Settings.baseUrl + url).then((res) => {
      if (res.data.success) {
        const filteredData = res?.data?.data?.field_dictionary?.filter(
          (item) => item.allow_in_condition === true
        );

        setFieldDictionaryData(filteredData);
      }
    })
  };

  const checkInstance = async () => {
    try {
      let api = Api;
      api.setUserToken();
      const res = await api.axios().get(`${Settings.baseUrl}instance/check-by-body-id?body_id=${workflowBodyId}`);
      return res?.data?.instance_exist
    } catch (err) {
      return false;
    }
  };

  const modalClose = () => { 
    props.hideConditionalModal(false);
    props.setOnClickNode();
  };

  const nodeDeleteHandler = async () => {
    const value = await checkInstance();
    if (value) {
      Helper.alert("This workflow have instance, so you can't delete", 'error');
    } else {
      setApiLoading(true);
      const formData = { "node_id": props.onClickNode };
      let api = Api;
      api.setUserToken();
      api.axios().post(Settings.baseUrl + 'workflow-node/delete', formData).then((res) => {
        if (res.data.success) {
          props.setDelete(true);
          modalClose();
          setApiLoading(false);
        }
      }).catch((error) => {
        getPopupMessageBasedOnStatus(error);
        setApiLoading(false);
      })
    };
  };

  return (
    <Popup onClose={modalClose} autoOpen={true} >
      <h3>Conditional decision</h3>
      <p>You must define a condition for conditional decision</p>
 
      {!props?.onClickNode && 
        <div className='d-flex gap-3 align-items-center'>
          <Input label="Label" className="col-6" onChange={(e) => { setnodeLabel(e.target.value) }} required value={nodeLabel} /> 
        </div>
      }

      {apiLoading ? <NewOverlayLoader isPopupInTab={true} /> : null}
      
      <ConditionalWorkflowModule 
        currentNode={props?.currentNode} 
        currentHandleId={props?.currentHandleId} 
        nodeLabel={nodeLabel}
        checkInstance={checkInstance} 
        workflowBodyId={workflowBodyId} 
        onClickNode={props?.onClickNode} 
        fieldDictionaryData={fieldDictionaryData} 
        save={props?.save} 
        addNode={props?.addNode}
        actionValue={props?.actionValue} 
        hideConditionalModal={props?.hideConditionalModal} 
        mainModal={props?.mainModal}
        nodeDeleteHandler={nodeDeleteHandler}
        onConditionalModalClose={modalClose}
      />

      <div className='d-flex justify-content-end mt-4'>
        <Button className="me-1" title="Close" onClick={modalClose} />
        {props.onClickNode && <Button className="mx-1 red-btn-style" title="Delete" isDisable={apiLoading} onClick={nodeDeleteHandler}/>}
      </div>
    </Popup>
  )
};

const mapStateToProps = (state) => {
  return {
    user:state.auth.user
  }
}

export default connect(mapStateToProps) (BasicSettings);